// Request-scoped correlation ID (ticket #124). The SPA stamps one UUIDv4 on
// each same-origin API request via the `X-Correlation-ID` header; the BFF
// preserves a canonical v4 and returns the authoritative value. The SPA keeps
// the value it generated so a failure that happens BEFORE the BFF (network
// error, no response) can still be reported against the operation's
// correlation ID in a diagnostic event.

export const CORRELATION_HEADER = "X-Correlation-ID";

export function newCorrelationId(): string {
  const c = globalThis.crypto;
  if (c?.randomUUID) return c.randomUUID();
  return fallbackV4(c);
}

// Only reached on legacy engines without crypto.randomUUID. Produces a
// canonical v4 so the BFF preserves it rather than replacing it.
function fallbackV4(c: Crypto | undefined): string {
  const bytes = new Uint8Array(16);
  if (c?.getRandomValues) {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant 10xx
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
  return (
    `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-` +
    `${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`
  );
}
